import React from "react";
import { ButtonComp } from "../Ui";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Yes, Continue",
  cancelText = "Cancel",
  confirmButtonClass = "bg-danger text-white",
  cancelButtonClass = "bg-secondary text-white",
  confirmButtonStyle,
  cancelButtonStyle,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="modal fade show d-block"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 10000,
      }}
      onClick={handleBackdropClick}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold text-dark">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body pt-2">
            {typeof message === "string" || typeof message === "number" ? (
              <p className="text-muted mb-0">{message}</p>
            ) : (
              <div className="text-muted mb-0">{message}</div>
            )}
          </div>
          <div className="modal-footer border-0 pt-3">
            <div className="row justify-content-around w-100 g-2">
              <div className="col-5">
                <ButtonComp
                  btnText={cancelText}
                  btnClassName={`${cancelButtonClass} px-4 py-2 border-0 rounded w-100`}
                  type="button"
                  onClick={onClose}
                  disabled={isLoading}
                  BorderColor={cancelButtonStyle ? undefined : "var(--color-primary)"}
                  ButtonInlineStyle={cancelButtonStyle}
                />
              </div>
              <div className="col-5">
                <ButtonComp
                  btnText={confirmText}
                  btnClassName={`${confirmButtonClass} px-4 py-2 border-0 rounded w-100`}
                  type="button"
                  onClick={onConfirm}
                  loading={isLoading}
                  disabled={isLoading}
                  ButtonInlineStyle={confirmButtonStyle}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
